import type { useTranslation } from "react-i18next";

export const translateValidatorError = (error: string, t: ReturnType<typeof useTranslation>["t"]): string => {
  switch (error) {
    case "missing value":
      return t("This field is required");
    case "Expecting a list of values but list is empty":
      return t("Please make a selection");
    case "Arrays should not contain more than 1000 elements":
      return t("Too many selections");
    case "Value has 0 length after escaping but field is required":
      return t("Please enter a valid value");
    case "Expecting string value":
      return t("Please enter a valid value");
    case "Phone number must be at least 10 digits":
      return t("Phone number must be at least 10 digits");
    case "Response must be a number":
      return t("Response must be a number");
    case "Not a valid number":
      return t("Please enter a valid number");
    case "Invalid date":
      return t("Please enter a valid date");
    // Literal bug in source — ${object} is not interpolated
    case "Expected a non-null object by got ${object}":
      return t("Please provide a valid response");
    case "Value must match one of file":
      return t("Please upload a file");
    case "Value must match one of signature":
      return t("Please complete the signature");
    case "Invalid boolean":
      return t("Please complete the signature");
    case "At least 1 choice is required":
      return t("At least 1 choice is required");
    case "No options provided":
      return t("No options provided");
    case "Only 1 choice is allowed":
      return t("Only 1 choice is allowed");
  }

  if (/^Expecting non-empty string but got/.test(error)) return t("Please enter a valid value");
  if (/^Expecting an object but got/.test(error)) return t("Please provide a valid response");
  if (/^Expecting a list of values but got/.test(error)) return t("Please make a selection");
  if (/^Length of escapedValue .+ exceeds maxLength/.test(error)) return t("Response exceeds maximum length");
  if (/^Length of JSON .+ exceeds maxLength/.test(error)) return t("Response exceeds maximum length");
  if (/^Invalid email:/.test(error)) return t("Please enter a valid email address");
  if (/^Expecting phone to be string but got/.test(error)) return t("Please enter a valid phone number");
  if (/^Invalid phone number:/.test(error)) return t("Please enter a valid phone number");
  if (/^Not a valid number for/.test(error)) return t("Please enter a valid number");
  if (/^Choice .+ is not a valid index$/.test(error)) return t("Invalid choice selected");
  if (/^Value must match one of/.test(error)) return t("Please provide a valid response");

  return error;
};
